import React from 'react';

import { Field } from 'formik';

import { getMoment } from '@libs/NwMoment';

import {
    NWTextAreaCharCounter,
    NWInput,
    NWSelect,
    NWCheckbox,
    NWDatePicker,
    NWBooleanSelector,
} from '@components/Gui/NwForm/NwFormItems';

const getCustomFieldInitialValue = (typeName, value) => {
    switch (typeName) {
        case 'MultipleChoice':
            return value ? value.split(',') : [];
        case 'Boolean':
            return value ? value : false;
        case 'Numeric':
            return value ? value : 0;
        case 'Date':
            return value ? getMoment(value) : '';
        default:
            return value ? value : '';
    }
};

const validateNumber = (value) => {
    let error;
    if (value.length > 0 && !/^[-+]?\d+$/.test(value)) {
        error = 'It should be integer';
    }
    return error;
};

const getCustomField = (values, customField, prefix) => {
    const fieldName = prefix ? `${prefix}${customField.Name}` : customField.Name;
    const fieldValue = values[fieldName];
    switch (customField.TypeName) {
        case 'String':
            return (
                <Field
                    component={NWInput}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                    type="text"
                    value={fieldValue}
                />
            );
        case 'MultipleLineString':
            return (
                <Field
                    component={NWTextAreaCharCounter}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                    type="text"
                    value={fieldValue}
                    maxLength={2000}
                    autoSize={{ minRows: 5, maxRows: 10 }}
                />
            );
        case 'Choice':
            return (
                <Field
                    component={NWSelect}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                    value={fieldValue}
                    options={customField.Options.map((option) => {
                        return { key: option, label: option, value: option };
                    })}
                />
            );
        case 'MultipleChoice':
            return (
                <Field
                    component={NWSelect}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                    value={fieldValue}
                    mode="tags"
                    options={customField.Options.map((option) => {
                        return { key: option, label: option, value: option };
                    })}
                />
            );
        case 'Boolean':
            return (
                <Field
                    component={NWCheckbox}
                    text={customField.Name.replace(/_/g, ' ')}
                    value={fieldValue}
                    name={fieldName}
                />
            );
        case 'Numeric':
            return (
                <Field
                    component={NWInput}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                    validate={validateNumber}
                    type="text"
                    value={fieldValue}
                />
            );
        case 'Date':
            return (
                <Field
                    component={NWDatePicker}
                    value={fieldValue}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={fieldName}
                />
            );
        default:
            return <div />;
    }
};

const getEmbeddedCustomField = (values, customField) => {
    switch (customField.TypeName) {
        case 'String':
            return (
                <Field
                    component={NWInput}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    type="text"
                    value={values.CustomFields[customField.Name]}
                />
            );
        case 'MultipleLineString':
            return (
                <Field
                    component={NWTextAreaCharCounter}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    type="text"
                    value={values.CustomFields[customField.Name]}
                    maxLength={2000}
                    autoSize={{ minRows: 5, maxRows: 10 }}
                />
            );
        case 'Choice':
            return (
                <Field
                    component={NWSelect}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    value={values.CustomFields[customField.Name]}
                    options={customField.Options.sort((a, b) => a.localeCompare(b)).map((option) => {
                        return { key: option, label: option, value: option };
                    })}
                />
            );
        case 'MultipleChoice':
            return (
                <Field
                    component={NWSelect}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    value={values.CustomFields[customField.Name]}
                    mode="tags"
                    options={customField.Options.sort((a, b) => a.localeCompare(b)).map((option) => {
                        return { key: option, label: option, value: option };
                    })}
                />
            );
        case 'Boolean':
            return (
                <Field
                    component={NWCheckbox}
                    text={customField.Name.replace(/_/g, ' ')}
                    value={values.CustomFields[customField.Name]}
                    name={`CustomFields.${customField.Name}`}
                />
                // <Field
                //     component={NWBooleanSelector}
                //     label={customField.Name.replace(/_/g, ' ')}
                //     value={values.CustomFields[customField.Name]}
                //     name={`CustomFields.${customField.Name}`}
                // />
            );
        case 'Numeric':
            return (
                <Field
                    component={NWInput}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    validate={validateNumber}
                    type="text"
                    value={values.CustomFields[customField.Name]}
                />
            );
        case 'Date':
            return (
                <Field
                    component={NWDatePicker}
                    value={values.CustomFields[customField.Name]}
                    label={customField.Name.replace(/_/g, ' ')}
                    name={`CustomFields.${customField.Name}`}
                    format="ddd DD MMM YY"
                />
            );
        default:
            return <div />;
    }
};

export { validateNumber, getCustomFieldInitialValue, getCustomField, getEmbeddedCustomField };
